<template>
  <div class="reset">
    <el-form :model="form" label-width="100px">
      <el-form-item label="设置密码">
        <el-input
            v-model="form.password"
            type="text"
            placeholder="重置密码"
            prefix-icon="el-icon-lock"
            autocomplete="off"
            clearable
            show-password/>
      </el-form-item>
      <el-form-item label="确认密码">
        <el-input
            v-model="form.newPassword"
            type="text"
            placeholder="确认密码"
            prefix-icon="el-icon-lock"
            autocomplete="off"
            clearable
            show-password/>
      </el-form-item>
      <el-form-item>
        <el-button type="success" style="margin-top: 30px;width: 200px;" @click="baocun">
          确认修改
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import { resetPwd } from "@/api/gw/user.js"
  export default {
    data(){
      return{
        form:{
          password:"",
          newPassword:"",
        },
        loading:false,
      }
    },
    methods:{
      baocun(){
        if(!this.form.password || !this.form.newPassword){
          this.$message.error("请输入密码");
          return;
        }
        if(this.form.password!=this.form.newPassword){
          this.$message.error("两次密码不一致");
          return;
        }
        this.loading = true
        resetPwd({
          password:this.form.password
        }).then(()=>{
          this.$message.success("修改密码成功");
          this.form = {
            password:"",
            newPassword:""
          };
        }).finally(()=>{
          this.loading = false
        })
      },
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/home/components/resetPass.vue